import { useEffect, useMemo, useState } from "react";
import type { ChallengeProps, InputType } from "./mfaTypes";

export const useChallenge = ({
  verify,
  authCode,
  authVars,
  shouldVerify = false,
  inputType = "digits",
}: Pick<ChallengeProps, "verify" | "authCode" | "shouldVerify" | "authVars"> & {
  inputType: InputType;
}) => {
  const [hasError, setHasError] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inputLength = inputType === "digits" ? 6 : 10;
  const isComplete = useMemo(() => {
    return authCode.replace(/[\s-]/g, "").length === inputLength;
  }, [authCode, inputLength]);

  useEffect(() => {
    let unmounting = false;
    async function challengeVerify() {
      setHasError(false);
      if (
        authCode.replace(/[\s-]/g, "").length === inputLength &&
        shouldVerify
      ) {
        setIsSubmitting(true);
        setIsVerified(false);
        const hasOutsideVerification = await verify({
          authCode,
          ...(authVars ? authVars : {}),
        });
        if (!unmounting) {
          setIsSubmitting(false);
          setIsVerified(!!hasOutsideVerification);
          setHasError(!hasOutsideVerification);
        }
      }
    }
    challengeVerify();
    return () => {
      unmounting = true;
    };
  }, [authCode, shouldVerify, inputLength]); //eslint-disable-line react-hooks/exhaustive-deps

  return { hasError, setHasError, isVerified, isSubmitting, isComplete };
};
